import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { map } from 'lodash';
import React from 'react';

interface DashboardTabsProps {
  tabsDisplayTexts: React.ReactNode[];
  tabs: string[];
  changeTab: (val: string) => void;
  activeTabIndex?: number;
  tabAriaLabels?: string[];
}

function a11yProps(index: number) {
  return {
    id: `dashboard-tab-${index}`,
    'aria-controls': `dashboard-tabpanel-${index}`,
  };
}

const DashboardTabs = ({ tabsDisplayTexts, changeTab, tabs, activeTabIndex, tabAriaLabels }: DashboardTabsProps) => {
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    changeTab(tabs[newValue]);
  };

  return (
    <Tabs
      value={activeTabIndex}
      onChange={handleChange}
      aria-label="dashboard tabs"
      variant="scrollable"
      scrollButtons="auto"
    >
      {map(tabsDisplayTexts, (title, i) => {
        return <Tab aria-label={tabAriaLabels?.[i]} label={title} key={tabs[i]} {...a11yProps(i)} />;
      })}
    </Tabs>
  );
};

export default DashboardTabs;
